import AgriAlertLocation from './agriAlertLocation';

export default AgriAlertLocation;